// Simple request deduplication service
class RequestDeduplicator {
  private pendingRequests = new Map<string, Promise<any>>();

  async dedupe<T>(key: string, requestFn: () => Promise<T>): Promise<T> {
    // If there's already a pending request for this key, return it
    if (this.pendingRequests.has(key)) {
      return this.pendingRequests.get(key) as Promise<T>;
    }

    // Start the request and store the promise
    const promise = requestFn()
      .finally(() => {
        // Clean up when request completes
        this.pendingRequests.delete(key);
      });

    this.pendingRequests.set(key, promise);
    return promise;
  }

  // Clear all pending requests (useful for cleanup)
  clear(): void {
    this.pendingRequests.clear();
  }

  // Check if a request is pending
  isPending(key: string): boolean {
    return this.pendingRequests.has(key);
  }
}

export const requestDeduplicator = new RequestDeduplicator();
